import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { default as DefaultGridParagraph } from "@mostlycode/ui/dist/Paragraphs/GridParagraph"
import Content from "components/Content"
import Container from "components/Container"
import ResponsiveImage from "components/ResponsiveImage"

const StyledParagraphImage = styled(DefaultGridParagraph)`
  margin: 4rem 0;

  ${(props) => props.theme.media.tablet_landscape_up`
    padding: 6rem 0;
    margin: 4rem auto;
  `}
`

const StyledParagraph = styled.article`
  grid-area: paragraph;
  padding: 2rem;
  display: flex;
  align-items: center;
  position: relative;
`

const StyledImageContainer = styled.div`
  grid-area: image;
  position: relative;
  z-index: 20;
  transform: translateY(2rem);
  margin: 0 2rem;
  border-radius: 5px;
  overflow: hidden;
  line-height: 1;
`

const StyledResponsiveImage = styled(ResponsiveImage)``

const StyledWrapper = styled.div`
  position: relative;
  z-index: 20;
  ${(props) => props.theme.media.tablet_landscape_up`
    max-width: 80%;
    margin: 0 auto;
  `}
`

const gridPhone = `"image" "paragraph"`
const gridTabletPortrait = `"image image image paragraph paragraph paragraph"`

function ParagraphImage({ image, content, theme, image_position, ...props }) {
  return (
    <Container>
      <StyledParagraphImage
        flipTabletPortrait={image_position}
        flipTabletLandscape={image_position}
        flipDesktop={image_position}
        flipBigDesktop={image_position}
        gridPhone={gridPhone}
        gridTabletLandscape={gridTabletPortrait}
        useFractions
        {...props}
      >
        <StyledParagraph>
          <StyledWrapper>
            <Content content={content} />
          </StyledWrapper>
          <div className="background" />
        </StyledParagraph>
        {image && (
          <StyledImageContainer flip={image_position}>
            <StyledResponsiveImage img={image} />
          </StyledImageContainer>
        )}
      </StyledParagraphImage>
    </Container>
  )
}

export default ParagraphImage

ParagraphImage.defaultProps = {}
ParagraphImage.propTypes = {
  content: PropTypes.array.isRequired,
  image: PropTypes.shape({
    fixed: PropTypes.object,
    fluid: PropTypes.object,
  }),
}
